import type { Tuple } from '@studio/react-utils';
import { useLatestFn } from '@studio/react-utils/hooks';
import { toNumber } from '@tryiris-ai/js-types';
import { isElement, merge } from 'lodash-es';
import { useMemo } from 'react';
import type { HandlerProps } from 'react-reflex';
import { DefaultLayout } from './constants.js';
import type { Layout } from './types.js';
import { usePrefState } from '#~/preferences/hooks.js';

/** @internal */
export const useLayoutPref = (): Tuple<Layout, HandlerProps> => {
  const [leftWidth, setLeftWidth] = usePrefState('room.left.width', DefaultLayout.left.minWidth);

  return [
    useMemo(() => merge({}, DefaultLayout, { left: { width: leftWidth } }), [leftWidth]),

    useLatestFn(({ domElement }: HandlerProps) => {
      if (isElement(domElement)) {
        const width = toNumber((<Element>domElement).clientWidth);

        if (width) {
          setLeftWidth(width);
        }
      }
    })
  ];
};
